import { type FullBudgetMixResponse } from "@north-beam/nb-common";

import { RecommendedMainTitleSection } from "./main-title-section";
import { TitleSectionContainer } from "./title-section-container";

export function RecommendedTitleSection({
  title,
  budgetMix,
  onClickDelete,
  openBudgetMixForecastModal,
  clientSettingColor,
}: {
  title: string;
  budgetMix: FullBudgetMixResponse;
  onClickDelete: () => void;
  openBudgetMixForecastModal: () => void;
  clientSettingColor: string | undefined;
}) {
  return (
    <TitleSectionContainer>
      <RecommendedMainTitleSection
        budgetMix={budgetMix}
        title={title}
        onClickDelete={onClickDelete}
        openBudgetMixForecastModal={openBudgetMixForecastModal}
        clientSettingColor={clientSettingColor}
      />
    </TitleSectionContainer>
  );
}
